import Slide from './src/slide.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToSlide: SFCWithInstall<typeof Slide> = withInstall(Slide)

export * from './src/instance'
